import ProductsScreen from '../screens/products'

export default ProductsScreen
